<template>
  <crud-modal
    :title="$t('modals.company.emailVerificationTitle')"
    action="send"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      {{ $t('modals.company.emailVerificationTextPrefix') }} <span class="font-semibold">{{ verificationEmail }}</span> {{ $t('modals.company.emailVerificationTextSuffix') }}
    </div>
    <div class="flex mb-2">
      {{ $t('modals.company.emailVerificationInfo') }}
    </div>
  </crud-modal>
</template>

<script>
import START_HOPPERMATION_ACTIVATION from '@/graphql/emailVerification/StartHoppermationActivation.gql'
import RESEND_HOPPERMATION_DEFAULT_SENDER_VALIDATION from '@/graphql/emailVerification/ResendHoppermationDefaultSenderValidation.gql'
import CrudModal from '@/components/modals/crud-modal'
import eventBus, { eventNames } from '@/lib/eventBus'

export default {
  components: { CrudModal },
  props: {
    companyId: {
      type: String,
      required: true
    },
    verificationEmail: {
      type: String,
      default: ''
    },
    updateQuery: {
      type: Function,
      required: true
    },
    defaultSender: {
      type: Object,
      default: null
    }
  },
  methods: {
    async submit () {
      try {
        if (!this.defaultSender) {
          await this.$apollo.mutate({
            mutation: START_HOPPERMATION_ACTIVATION,
            variables: { companyId: this.companyId },
            update: this.updateQuery
          })
        } else {
          await this.$apollo.mutate({
            mutation: RESEND_HOPPERMATION_DEFAULT_SENDER_VALIDATION,
            variables: { companyId: this.companyId }
          })
        }
      } catch (err) {
        eventBus.$emit(eventNames.SHOW_SNACKBAR, { type: 'error', text: this.$t('modals.company.emailVerificationError') })
      }
    }
  }
}
</script>
